document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tcw-tab-btn').forEach(function (btn, index) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.tcw-tab-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      document.querySelectorAll('.tcw-tab-content').forEach(function (c) {
        c.classList.remove('active');
      });
      this.classList.add('active');
      document.getElementById('tab' + (index + 1)).classList.add('active');
    });
  });
});
